module.exports = __webpack_public_path__ + "img/medication.76800386.png";